<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.68377 9.9487C1.77208 9.6448 1.77208 8.35524 2.68377 8.05134L20.6838 2.05134C21.4655 1.79075 22.2093 2.53449 21.9487 3.31625L15.9487 21.3162C15.6448 22.2279 14.3552 22.2279 14.0513 21.3162L11.2094 12.7906L2.68377 9.9487ZM6.16228 9.00002L12.3162 11.0513C12.6148 11.1509 12.8491 11.3852 12.9487 11.6838L15 17.8377L19.4189 4.58116L6.16228 9.00002Z"
    fill="currentColor"
  />
</svg>
